import { render, staticRenderFns } from "./RulesByApprovalWorkflowFilter.vue?vue&type=template&id=18a26840"
import script from "./RulesByApprovalWorkflowFilter.vue?vue&type=script&lang=js"
export * from "./RulesByApprovalWorkflowFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports